var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorLoadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.85 50.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{fill:none;stroke:#e6e6e6;stroke-width:3.25px;}.cls-2{stroke-miterlimit:8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.24,21v19.39c0,2.28.91,4.48,2.52,6.09,1.62,1.62,3.81,2.52,6.09,2.52h30.15c2.28,0,4.48-.91,6.09-2.52,1.62-1.62,2.52-3.81,2.52-6.09v-2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.62,29.61V10.24c0-2.28-.91-4.48-2.52-6.09-1.62-1.62-3.81-2.52-6.09-2.52h-30.15c-2.28,0-4.48.91-6.09,2.52-1.62,1.62-2.52,3.81-2.52,6.09v2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.85,29.61l-8.61-8.61L1.62,29.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49,21l8.61,8.61,8.61-8.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.93,10.3v17.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.93,39.38c-.59,0-1.08-.48-1.08-1.08s.48-1.08,1.08-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.93,39.38c.59,0,1.08-.48,1.08-1.08s-.48-1.08-1.08-1.08"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLoadIcon);
export default __webpack_public_path__ + "static/media/ErrorLoadIcon.caa466b59324af68c0129a999961437b.svg";
export { ForwardRef as ReactComponent };